import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Gray_Light_900 } from '@common/styles';

export const Root = styled.div`
  padding: 8px 0 20px;
`;

export const Title = styled.h3`
  padding: 12px 16px;
  color: ${Gray_Light_900};
  margin-bottom: 4px;
`;

export const mb2 = css`
  margin-bottom: 2px;
`;

export const mb4 = css`
  margin-bottom: 4px;
`;
